export default __webpack_public_path__ + "static/media/consumer_background.2e9a92a4.png";